/* eslint-disable @typescript-eslint/naming-convention */

export interface PreSignedUrlData {
    presigned_url: string;
    request_id: string;
    aws_fields: Record<string, string>;
}

export interface PreSignedUrlResponse {
    statusCode: number;
    statusMessage: string;
    data?: PreSignedUrlData;
}

export interface JobSubmitResponse {
    statusCode: number;
    statusMessage: string;
    request_id?: string;
}

export enum PreSignedUrlJobStatus {
    PROCESSING = "PROCESSING",
    COMPLETED = "COMPLETED",
}

export interface JobStatusResponse {
    statusCode: number;
    statusMessage: string;
    jobstatus?: PreSignedUrlJobStatus;
    request_id?: string;
}

export enum PC_HALFCARD_STATES {
    INSTRUCTIONS = "INSTRUCTIONS",
    UPLOAD_IMAGE = "UPLOAD_IMAGE",
    SCANNING = "SCANNING",
    /** Terminal: job completed with an acceptable outcome (includes “rejected” UX). */
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    IMAGE_TOO_LARGE_ERROR = "IMAGE_TOO_LARGE_ERROR",
}

export interface IToingPriceComparisonBEData {
    is_free_cash_applicable?: boolean;
    instructions_data?: {
        lottie_id?: string;
        free_cash_multiplier?: string;
    };
    scanning_states_data?: {
        lottie_id?: string;
    };
    rejection_state_halfcard_data?: {
        icon?: string;
        title?: string;
        subtitle?: string;
        error_image?: string;
        cta?: {
            icon?: string;
            text?: string;
        };
    };
    success_state_halfcard_data?: {
        type?: string;
        lottie_id?: string;
        prev_bill_amt?: string;
        current_bill_amt?: string;
        free_cash_amt?: string;
        diff_in_amt?: string;
    };
}

export enum FreeCashRemovalPopupVariant {
    ITEM_REMOVAL = "ITEM_REMOVAL",
    MENU_NAVIGATION = "MENU_NAVIGATION",
}
